import { useState } from 'react';
import ReactGA from 'react-ga4';
import { Offer, PassengerLegBaggage, PassengerPricing } from '~/types';
import { Collapse, Divider } from '@mui/material';
import FlightCardItemDetailed from './FlightCardItemDetailed';
import FlightCardItemOverview from './FlightCardItemOverview';
import { Box } from '@mui/system';

interface ItineraryCardProps {
  offer: Offer;
  passengerPricing: PassengerPricing[];
  passengerLegBaggage?: PassengerLegBaggage[];
  isSearchPage?: boolean;
}

const FlightCardItemDetailsCollapsible = ({ offer, passengerPricing, passengerLegBaggage, isSearchPage = false }: ItineraryCardProps) => {
  const itineraries = offer.itineraries;
  const outbound = itineraries.outbound;
  const inbound = itineraries.inbound ? itineraries.inbound : null;

  const [showOutboundDetails, setShowOutboundDetails] = useState(false);
  const [showInboundDetails, setShowInboundDetails] = useState(false);

  const handleOutboundToggleDetails = () => {
    // track details toggle
    ReactGA.event({
      category: 'FlightBooking',
      action: showOutboundDetails ? 'Flight Booking Outbound Details Collapsed' : 'Flight Booking Outbound Details Expanded',
      label: `booking_${offer.offerId}`,
    });

    setShowOutboundDetails(!showOutboundDetails);
  };

  const handleInboundToggleDetails = () => {
    // track details toggle
    ReactGA.event({
      category: 'FlightBooking',
      action: showInboundDetails ? 'Flight Booking Inbound Details Collapsed' : 'Flight Booking Inbound Details Expanded',
      label: `booking_${offer.offerId}`,
    });
    setShowInboundDetails(!showInboundDetails);
  };

  return (
    <Box style={{ padding: 20 }}>
      <Collapse in={!showOutboundDetails} timeout="auto" unmountOnExit>
        <FlightCardItemOverview
          legGroup={outbound}
          passengerPricing={passengerPricing}
          onDetailsButtonClicked={handleOutboundToggleDetails}
          passengerLegBaggage={passengerLegBaggage}
          isSearchPage={isSearchPage}
        />
      </Collapse>
      <Collapse in={showOutboundDetails} timeout="auto" unmountOnExit>
        <FlightCardItemDetailed
          legGroup={outbound}
          passengerPricing={passengerPricing}
          passengerLegBaggage={passengerLegBaggage}
        />
      </Collapse>
      {
        inbound &&
        <Divider sx={{ marginTop: 5, marginBottom: 5 }} />
      }
      {
        inbound &&
        <Collapse in={!showInboundDetails} timeout="auto" unmountOnExit>
          <FlightCardItemOverview
            legGroup={inbound}
            passengerPricing={passengerPricing}
            onDetailsButtonClicked={handleInboundToggleDetails}
            passengerLegBaggage={passengerLegBaggage}
            isSearchPage={isSearchPage}
          />
        </Collapse>
      }
      {
        inbound &&
        <Collapse in={showInboundDetails} timeout="auto" unmountOnExit>
          <FlightCardItemDetailed
            legGroup={inbound}
            passengerPricing={passengerPricing}
            passengerLegBaggage={passengerLegBaggage}
          />
        </Collapse>
      }
    </Box>
  );
};

export default FlightCardItemDetailsCollapsible;

